import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const CheckBoxProcedimentosFormik = ({ formik, field }) => {
  const [procedimento, setProcedimento] = useState([]);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");
  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (formik.values.sequencialTipoAcao) {
      const params = { sqTipoAcaoFiscal: formik.values.sequencialTipoAcao };
      request(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentosPorAcao, params);
    }

    if (formik.values.sequencialTipoAcaoFiscalNovo) {
      const params = { sqTipoAcaoFiscal: formik.values.sequencialTipoAcaoFiscalNovo };
      request(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentosPorAcao, params);
    }

    if (formik.values.nuTipoAcaoFiscal) {
      const params = { sqTipoAcaoFiscal: formik.values.nuTipoAcaoFiscal };
      request(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentosPorAcao, params);
    }
  }, [
    request,
    formik.values.sequencialTipoAcao,
    formik.values.sequencialTipoAcaoFiscalNovo,
    formik.values.nuTipoAcaoFiscal,
  ]);

  useEffect(() => {
    if (data) {
      setshowErro(false);
      setProcedimento(data.result);
    }

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  const { setValues } = formik;

  useEffect(() => {
    setValues((curr) => {
      const newValues = { ...curr };
      if (curr.numeroAberturaProcesso === "") {
        newValues.procedimentos = [];
      }
      return newValues;
    });
  }, [formik.values.sequencialTipoAcao, formik.values.nuTipoAcaoFiscal, setValues]);

  const changeHandler = (event) => {
    if (event.target.checked && formik.values[field].indexOf(event.target.id) === -1) {
      formik.values[field].push(event.target.id);
    } else {
      formik.values[field].splice(formik.values[field].indexOf(event.target.id), 1);
    }
  };

  if (showErro) {
    return (
      <>
        <br />
        <div className="alert alert-danger" role="alert">
          {messageErro}
        </div>
      </>
    );
  }

  if (isLoading) {
    return (
      <span>
        <Spinner animation="border" role="status" />
        Carregando Procedimentos...
      </span>
    );
  }

  if (!procedimento?.length || formik.values?.nuTipoAcaoFiscal === "") {
    return null;
  }

  const isChecked = (item) => !!formik.values.procedimentos.find((element) => parseInt(element, 10) === item.codigo);

  return (
    <>
      <Form.Label>Procedimentos</Form.Label>
      {procedimento.map((item) => (
        <>
          <Form.Check
            key={item.codigo}
            type="checkbox"
            id={item.codigo}
            name={field}
            label={item.nome}
            disabled={formik.isSubmitting}
            defaultChecked={isChecked(item)}
            onChange={(event) => changeHandler(event, item.codigo)}
            isInvalid={formik.touched[field] && formik.errors[field]}
          />
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      ))}
    </>
  );
};

export default CheckBoxProcedimentosFormik;
